import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { GanttElemento } from "@/types/api";

export function useGantt() {
  return useQuery({
    queryKey: ["gantt"],
    queryFn: () => apiFetch<GanttElemento[]>("/api/v1/gantt"),
    staleTime: 5 * 60_000,
  });
}
